import { useMemo, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { defaultLondonLocation } from "../components/map/SellarMap.shared";
import { useSupplierListByDistance } from "./api/v2/supplier/useSupplierListByDistance";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useVariableSupplierDistanceQuery = ({
  limit,
}: {
  limit?: number;
}) => {
  const { business } = useSellarCurrentBusiness();
  const [supplierDistance, setSupplierDistance] = useState(40);
  const [hiddenAddToListSuppliersIds] = useLocalStorage<number[]>(
    "hiddenAddToListSuppliersIds",
    [],
  );

  const suppliersByDistanceQuery = useSupplierListByDistance(
    {
      offset: 0,
      limit: limit ?? 15,
      lng: business?.Location?.lng ?? defaultLondonLocation.lng,
      lat: business?.Location?.lat ?? defaultLondonLocation.lat,
      distance: supplierDistance,
      ignoreSupplierIds: hiddenAddToListSuppliersIds,
      orderBy: "distance",
      unConnectedOnly: true,
      includeProfiles: true,
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  const queryData = suppliersByDistanceQuery.data;
  const [processedQueryData, setProcessedQueryData] =
    useState<typeof queryData>();
  const firstPage = queryData?.pages[0];
  const needsMoreDistance = queryData?.pages.length
    ? !!firstPage && firstPage.length < 15
    : false;

  if (suppliersByDistanceQuery.isFetched && queryData !== processedQueryData) {
    setProcessedQueryData(queryData);
    if (needsMoreDistance && supplierDistance < 100) {
      setSupplierDistance(supplierDistance + 20);
    }
  }

  const suppliers = useMemo(
    () => suppliersByDistanceQuery.data?.pages.flatMap((page) => page) ?? [],
    [suppliersByDistanceQuery.data],
  );

  const isLoading = suppliersByDistanceQuery.isLoading;

  return {
    isLoading,
    suppliers,
  };
};
